<template>
  <div class="dashboard">
    <dashboard-stats />
    <dashboard-table :ccn="ccn" :verif="verif" :liquidation="liquidation" />
  </div>
</template>

<script>
import DashboardStats from "./DashboardStats";
import DashboardTable from "./DashboardTable";

export default {
  name: "dashboard",
  props: ["ccn", "codeape", "verif", "liquidation"],
  components: {
    DashboardStats,
    DashboardTable,
  },

  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}
</style>
